var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"footer"},[_c('p',{staticClass:"footerTxt"},[_vm._v(_vm._s(_vm.$t('spine-tips1')))]),_c('p',{staticClass:"footerTxt"},[_vm._v("@ "+_vm._s(_vm.$t('spine-tips2')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }